import { reactive } from 'vue';

export interface MenuItem {
  id: string;
  itemtype: string;
  route?: { name: string };
  title: string;
  url: string;
  iconclass: string;
  showbadge: boolean;
  badgecontent: string;
  targetnew: boolean;
  targettop: boolean;
}

export const menu = reactive({
  show: false,
  items: [[]] as MenuItem[][],
  set: (value: boolean) => (menu.show = value),
  toggle: () => (menu.show = !menu.show)
});
